import { render, staticRenderFns } from "./MaterialSetup.vue?vue&type=template&id=631ce28c&"
import script from "./MaterialSetup.vue?vue&type=script&lang=js&"
export * from "./MaterialSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('631ce28c')) {
      api.createRecord('631ce28c', component.options)
    } else {
      api.reload('631ce28c', component.options)
    }
    module.hot.accept("./MaterialSetup.vue?vue&type=template&id=631ce28c&", function () {
      api.rerender('631ce28c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/Study/MaterialSetup.vue"
export default component.exports